import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.pruefplan-rollen-pruefer-admin';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanRollenPrueferAdminEffects {

    PruefplanRollenPrueferAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFPLAN_ROLLEN_PRUEFER_ADMIN),
        mergeMap((x: ac.GetPruefplanRollenPrueferAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPruefplanRollenPrueferAdmin(x.pruefplan_id).pipe(
                map((result: any) => {
                    return new ac.GetPruefplanRollenPrueferAdminErfolgreichAction(result, x.pruefplan_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPruefplanRollenPrueferAdminFehlerAction(error, x.pruefplan_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminQueryService);
        }
        return this.service;
    }
}
